<aside class="side-navigation" [class.is-collapsed]="collapsed" aria-label="Workspace navigation" (keydown)="onMenuKeydown($event)">
  <ng-template #navigationBody let-inDrawer="inDrawer">
  <div class="navigation-body" [class.in-mobile-drawer]="inDrawer">
  <nav class="navigation-links" aria-label="Primary navigation">
    @for (item of navigationItems; track item.route) {
      <app-tooltip [label]="item.label" [disabled]="inDrawer || !collapsed" placement="right">
      <a
        class="navigation-link"
        [routerLink]="item.route"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          @switch (item.icon) {
            @case ('chat') { <path d="M21 11.5a8.5 8.5 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" /><path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01" /> }
            @case ('documents') { <path d="M7 3.5h7l4 4v13H7a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2Z" /><path d="M14 3.5v4h4M9 12h6M9 16h6" /> }
            @case ('receipt') { <path d="M6 3l2 1.5L10 3l2 1.5L12 3l2 1.5L16 3l2 1.5V21l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21V3Z" /><path d="M9 9h6M9 13h6M9 17h4" /> }
            @case ('settings') { <circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.83l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 19.4a1.7 1.7 0 0 0-1.83.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.34-1.83l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 4.6a1.7 1.7 0 0 0 1.83-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9c.2.61.78 1.02 1.43 1H21a2 2 0 1 1 0 4h-.09c-.65 0-1.23.4-1.51 1Z" /> }
          }
        </svg>
        <span>{{ item.label }}</span>
      </a>
      </app-tooltip>
    }
  </nav>

  @if (skillsItems.length) {
    <div #skillsDropdown class="skills-dropdown">
      <app-tooltip label="Skills" [disabled]="inDrawer || !collapsed" placement="right">
      <button
        class="navigation-link skills-toggle"
        [class.is-active]="skillsActive()"
        type="button"
        aria-controls="skills-menu"
        [attr.aria-expanded]="skillsOpen()"
        (click)="toggleSkills()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" /></svg>
        <span>Skills</span>
        <svg class="skills-chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </button>
      </app-tooltip>
      <div id="skills-menu" class="skills-menu" [class.is-open]="skillsOpen()">
        @for (item of skillsItems; track item.route) {
          <a
            class="navigation-link skill-link"
            [routerLink]="item.route"
            routerLinkActive="is-active"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              @switch (item.icon) {
                @case ('receipt') { <path d="M6 3l2 1.5L10 3l2 1.5L12 3l2 1.5L16 3l2 1.5V21l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21V3Z" /><path d="M9 9h6M9 13h6M9 17h4" /> }
              }
            </svg>
            <span>{{ item.label }}</span>
          </a>
        }
      </div>
    </div>
  }

  @if (threads.length) {
    <section class="recent-chats" aria-labelledby="recent-chats-title">
      <h2 id="recent-chats-title">Recent chats</h2>
      <div class="recent-chat-list">
        @for (thread of threads.slice(0, 8); track thread.id) {
          <app-tooltip [label]="thread.title" [disabled]="inDrawer" placement="right">
            <a class="recent-chat-link" [routerLink]="['/chat', thread.id]" routerLinkActive="is-active">
              <span>{{ thread.title }}</span>
            </a>
          </app-tooltip>
        }
      </div>
    </section>
  }

  <div class="navigation-footer">
    <app-tooltip label="Settings" [disabled]="inDrawer || !collapsed" placement="right">
      <a
        class="navigation-link"
        routerLink="/settings"
        routerLinkActive="is-active"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.83l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 19.4a1.7 1.7 0 0 0-1-1.55 1.7 1.7 0 0 0-1.83.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.34-1.83l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 4.6a1.7 1.7 0 0 0 1.83-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9c.2.61.78 1.02 1.43 1H21a2 2 0 1 1 0 4h-.09c-.65 0-1.23.4-1.51 1.51Z" />
        </svg>
        <span>Settings</span>
      </a>
    </app-tooltip>
    <app-tooltip label="Sign out" [disabled]="inDrawer || !collapsed" placement="right">
      <button class="navigation-link sign-out-button" type="button" (click)="requestSignOut()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 17l5-5-5-5M15 12H3M21 19V5a2 2 0 0 0-2-2h-6" /></svg>
        <span>Sign out</span>
      </button>
    </app-tooltip>
    <app-tooltip label="Private workspace" [disabled]="inDrawer || !collapsed" placement="top">
      <div class="workspace-status">
        <span class="status-dot" aria-hidden="true"></span>
        <span>Private workspace</span>
      </div>
    </app-tooltip>
  </div>
  </div>
  </ng-template>

  <div class="navigation-top">
    <a class="brand" routerLink="/chat" aria-label="Serg home" (click)="onBrandClick($event)">
      <span class="brand-mark" aria-hidden="true">S</span>
      <span class="brand-name">Serg</span>
    </a>

    <app-tooltip label="New chat" [disabled]="!collapsed" placement="right">
      <button class="new-chat-button" type="button" (click)="startNewChat()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
        <span>New chat</span>
      </button>
    </app-tooltip>

    <button
      #menuButton
      class="navigation-icon-button menu-button"
      type="button"
      aria-label="Menu"
      aria-haspopup="dialog"
      aria-controls="mobile-navigation"
      [attr.aria-expanded]="mobileOpen()"
      (click)="toggleMobileMenu()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
    </button>

    <app-tooltip [label]="collapsed ? 'Expand navigation' : 'Collapse navigation'" [disabled]="!collapsed" placement="right">
      <button
        class="navigation-icon-button collapse-button"
        type="button"
        [attr.aria-label]="collapsed ? 'Expand navigation' : 'Collapse navigation'"
        [attr.aria-expanded]="!collapsed"
        (click)="toggleCollapsed()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
      </button>
    </app-tooltip>
  </div>

  <ng-container *ngTemplateOutlet="navigationBody" />

  <div
    id="mobile-navigation"
    #drawer
    class="mobile-navigation"
    [class.is-open]="mobileOpen()"
    role="dialog"
    aria-modal="true"
    aria-label="Menu"
    tabindex="-1"
    (click)="onMenuBackdropClick($event)"
  >
    <div class="mobile-navigation-panel">
      <ng-container *ngTemplateOutlet="navigationBody; context: { inDrawer: true }" />
    </div>
  </div>
</aside>
